import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';

import { of } from 'rxjs';
import { tap } from 'rxjs/operators';

import { AuthenticationService } from 'cl-common-angular';

import { Auth } from './auth';
import { AvatarService } from './avatar.service';

@Injectable({
    providedIn: 'root'
})
export class AuthService implements AuthenticationService {

    private readonly routePrefix: string = 'api/auth';

    private auth: Auth;

    constructor(private avatarService: AvatarService, private httpClient: HttpClient, private title: Title) { }

    getAuthInfo = () => this.auth ? of(this.auth) : this.httpClient.get<Auth>(this.routePrefix)
        .pipe(
            tap(data => this.auth = data),
            tap(data => { if (data.isAuthenticated) this.avatarService.loadAvatar(); }),
            tap(data => this.title.setTitle(data.productName))
        )

}
